{
  "required": "Pole wymagane",
  "maxlength": "Maksymalna liczba znaków to: {{0}}",
  "minlength": "Minimalna liczba znaków to: {{0}}",
  "invalidNip": "Niepoprawny numer NIP",
  "invalidRegon": "Niepoprawny numer REGON",
  "positiveIntegerNumberPattern": "Wymagany format 123",
  "positiveDecimalNumberPattern": "Wymagany format 123,45",
  "number": "Wymagany format liczbowy",
  "atLeastOneRequired": "Wymagany przynajmniej jeden element",
  "invalidPesel": "Niepoprawny numer PESEL",
  "invalidPhoneNumber": "Niepoprawny numer telefonu",
  "invalidEmail": "Niepoprawny email",
  "invalidDateFormat": "Niepoprawna data. Wymagany format DD-MM-YYYY",
  "invalidRange": "Nieprawdiłowy zakres",
  "postcodePattern": "Wymagany format 00-000",
  "datePattern": "Wymagany format DD-MM-YYYY",
  "dateAfterToday": "Data nie może być późniejsza niż dzisiaj",
  "dateBeforeToday": "Data nie może być wcześniejsza niż dzisiaj",
  "maxDate": "Maksymalna data to {{maxDate}}",
  "minDate": "Minimalna data to {{minDate}}",
  "pattern": "Niepoprawny format",
  "min": "Minimalna dozwolona liczba to {{0}}",
  "max": "Maksymalna dozwolona liczba to {{0}}",
  "invalidData": "Niepoprawna wartość",
  "invalidPhoneFormat": "Niepoprawny format. Wymagane 9-18 cyfr",
  "invalidKrsFormat": "Niepoprawny format. Wymagane 10 cyfr",
  "maxAmount": "Maksymalna dozwolona kwota to: {{max}}"
}
